// extracted by mini-css-extract-plugin
export default {"alertBoxWrapper":"AlertPopup_alertBoxWrapper__QiuFe"};